import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=642b59d8&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=ts&"
export * from "./BusinessProfile.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=642b59d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b59d8",
  null
  
)

export default component.exports